/* eslint-disable no-unused-vars */
import { memo, useMemo, useState } from 'react';
import { default as DateTimePicker } from 'react-datepicker';
import CustomHeader from './components/header/Header';
import DatePickerInput from './components/datePickerInput/DatePickerInput';
import { Calendar, DeleteIcon } from 'assets/icons';

const DatePicker = ({
  selectedDate,
  handleChangeDate,
  minDate,
  fieldName,
  onCalendarOpen,
  styledInput,
  disabled,
  disabledPicker,
  rightIconAction,
  error,
}) => {
  const [isOpen, setIsOpen] = useState('false');
  const handleOpen = () => {
    setIsOpen('true');
  };

  const handleClose = () => {
    setIsOpen('false');
  };

  return (
    <DateTimePicker
      openToDate={minDate}
      disabled={disabledPicker(selectedDate)}
      minDate={minDate}
      onCalendarClose={handleClose}
      onCalendarOpen={handleOpen}
      customInput={
        <DatePickerInput
          error={error}
          isOpen={isOpen}
          disabled={disabledPicker(selectedDate)}
          leftIcon={<Calendar />}
          moveInputLeft={20}
          showCalendar
          selected={selectedDate}
          styledInput={styledInput}
          autoComplete='off'
          placeholderText='DD/MM/YYYY'
          rightIcon={<DeleteIcon />}
          rightIconAction={rightIconAction}
        />
      }
      showPopperArrow={false}
      calendarClassName='dateTimePicker'
      dateFormat='dd/MM/yyyy'
      selected={selectedDate}
      onChange={(value) => handleChangeDate(value, fieldName)}
      renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
        <CustomHeader
          minDate={minDate}
          date={date}
          decreaseMonth={decreaseMonth}
          increaseMonth={increaseMonth}
        />
      )}
    />
  );
};

export default memo(DatePicker);
